import { Avatar, Tooltip } from '@commenda/kakashi';
import {
  IUnreadChatRoomMessage,
  UserTypes,
} from '@commenda/types/src/chat-room/types';
import { trimTextName } from '@commenda/utils/trim-file-name';
import { KeyedMutator } from 'swr';

const ThreadsChatMessage = ({
  message,
  getUnreadMessagesMutate,
  userType,
}: {
  message: IUnreadChatRoomMessage;
  getUnreadMessagesMutate: KeyedMutator<unknown>;
  userType: UserTypes;
}) => {
  return (
    <div className="flex items-center gap-3 px-2 py-4 border-b border-border-primary cursor-pointer hover:bg-bg-secondary">
      <Avatar name={message.createdBy} />

      <div className="flex flex-col flex-grow min-w-0">
        <div className="flex justify-between items-start">
          <div className="txt-small-medium text-text-quaternary truncate">
            <div className="flex items-center gap-1">
              {message.filingName && (
                <>
                  <Tooltip content={message.filingName} side="bottom">
                    <span className="text-text-secondary text-ellipsis">
                      {trimTextName(message.filingName, 7)}
                    </span>
                  </Tooltip>

                  <span className="text-fg-quaternary">•</span>
                </>
              )}
              <Tooltip content={message.corporationName || ''} side="bottom">
                <span>{trimTextName(message.corporationName || '', 12)}</span>
              </Tooltip>
            </div>
          </div>
          <div className="text-fg-quinary text-xs font-normal ml-2 flex-shrink-0">
            {message.createdAt}
          </div>
        </div>
        <div className="mt-2 txt-small-medium text-text-primary truncate">
          {message.createdBy}: {message.activityType}
        </div>
      </div>
    </div>
  );
};

export { ThreadsChatMessage };
